import {hasValue} from '@famly/stat_ts-utils_has-value';

import {getQueryParams} from './get-query-params';

/**
 * Use this to update query parameters with the browser's API.
 *
 * "When should I use this?"
 * - NOT if you're in a react-router dependant route then use `useUpdateQueryParams`
 * - DO use this if your feature lives outside react-router or is used across routes
 * @deprecated
 */
export const updateQueryParams = (
    cb: (params: URLSearchParams) => URLSearchParams,
    options?: {replace?: boolean; onlyHash?: boolean},
) => {
    const [url, params] = getQueryParams(options?.onlyHash);
    const searchParams = cb(params);

    const addParamsToURL = (baseURL: string, params: URLSearchParams) => {
        if (params.toString().length === 0) {
            return baseURL;
        }
        return `${baseURL}?${params.toString()}`;
    };

    const newUrl = addParamsToURL(url, searchParams);

    if (hasValue(options) && options.replace) {
        window.history.replaceState(undefined, window.document.title, newUrl);
    } else if (options?.onlyHash) {
        window.location.hash = newUrl;
    } else {
        window.location.href = newUrl;
    }
};
